/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUploadAssetUrlBody
 */
export interface GetUploadAssetUrlBody {
    /**
     * 
     * @type {string}
     * @memberof GetUploadAssetUrlBody
     */
    contentType: string;
}

export function GetUploadAssetUrlBodyFromJSON(json: any): GetUploadAssetUrlBody {
    return GetUploadAssetUrlBodyFromJSONTyped(json, false);
}

export function GetUploadAssetUrlBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUploadAssetUrlBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contentType': json['contentType'],
    };
}

export function GetUploadAssetUrlBodyToJSON(value?: GetUploadAssetUrlBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contentType': value.contentType,
    };
}


